import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import "@/assets/css/main.css"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { faAngleLeft, faAngleRight, faCheck, faBars, faMinusCircle, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

const datepickerOptions = {}
library.add(faUser, faAngleLeft, faAngleRight, faBars, faCheck, faMinusCircle, faPlus)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMoment)
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

Vue.config.productionTip = true

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
